import {forOwn, set, cloneDeep, unset} from 'lodash';
import {STANDARD_DATE_TIME_FORMAT} from "Core/const/datetime";
import {getDateString} from "Core/helpers/datetime";
import {getString, removeEmptyObjectProps, resetObjectValues} from 'Core/helpers/data';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data.
 * @param {boolean} [ignoreProjectId=false] - Flag that specifies if applied 'projectId' filter value is ignored.
 * @return {Object}
 */
export const input = (rawData, ignoreProjectId = false) => {
	let result = cloneDeep(rawData);

	forOwn(result, (value, key) => {
		// Cast project ID to string so that multi select will recognize the value
		if (!ignoreProjectId && key === 'projectId' && !!value) set(result, key, getString(value));
	});
	
	if (ignoreProjectId && result.hasOwnProperty('projectId')) unset(result, 'projectId');

	return result;
}

/**
 * Get output data from input data
 * @param {Object} input - Input value.
 * @return {Object}
 */
export const output = input => {
	let result = cloneDeep(input);

	forOwn(result, (value, key) => {
		// Convert a Date object to an appropriate date string
		if (value instanceof Date) set(result, key, getDateString(value, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S));
	});
	
	// Set proper empty values expected by the API
	result = removeEmptyObjectProps(resetObjectValues(result));

	return result;
}